import React, { useState } from "react";
import VisitsDrawer from "../patient/VisitsDrawer";
import CodeListTable from "./CodeListTable";

export default function CodeList({
  codes,
  loading,
}: {
  codes?: CodeBase[];
  loading: boolean;
}) {
  const [visitToLoad, setVisitToLoad] = useState<string | null>(null);

  // here will be the logic to implement the search input
  function closeVisitsDrawer() {
    setVisitToLoad(null);
  }

  function onOpenVisit(visitId: string) {
    setVisitToLoad(visitId);
  }

  return (
    <>
      <CodeListTable
        codes={codes}
        loading={loading}
        onOpenVisit={onOpenVisit}
      />
      {visitToLoad && (
        <VisitsDrawer
          toggleDrawer={closeVisitsDrawer}
          initialVisitId={visitToLoad}
        />
      )}
    </>
  );
}
